// Function to check and remove the specific manifest tag
const removeTargetTag = (node) => {
    if (node.nodeType === 1 && 
        node.tagName === 'LINK' && 
        node.getAttribute('data-pushowl-manifest') === 'true') {
        
        node.remove();
        console.log('Target manifest tag identified and removed.');
    }
};

// Create an observer to watch the <head> for changes
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            removeTargetTag(node);
        });
    });
});

// Start observing the document head
observer.observe(document.head, {
    childList: true,
    subtree: true
});

// Run an initial check in case it's already there when the script loads
const existingTag = document.querySelector('link[data-pushowl-manifest="true"]');
if (existingTag) existingTag.remove();